import { render, staticRenderFns } from "./Transport.vue?vue&type=template&id=10c9f1ee&scoped=true"
import script from "./Transport.vue?vue&type=script&lang=js"
export * from "./Transport.vue?vue&type=script&lang=js"
import style0 from "./Transport.vue?vue&type=style&index=0&id=10c9f1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c9f1ee",
  null
  
)

export default component.exports